import {config} from "./config";
import {request} from "./request";

function updateMpAuthConfig(data, cb, fail_cb) {
    request.post.call(this, config.apiList.mpAuthConfigs, data, null, cb, fail_cb)
}

function getUsers(data, cb, fail_cb) {
    request.get.call(this, config.apiList.users, data, cb, fail_cb)
}

function getUnionUsers(data, cb, fail_cb) {
    request.get.call(this, config.apiList.unionUsers, data, cb, fail_cb)
}

function sendServiceChange(data, cb, fail_cb) {
    request.get.call(this, config.apiList.sendServiceChange, data, cb, fail_cb)
}

function addToBlacklist(data, cb, fail_cb) {
    request.get.call(this, config.apiList.addToBlacklist, data, cb, fail_cb)
}

function setOnlyBindUser(data, cb, fail_cb) {
    request.get.call(this, config.apiList.setOnlyBindUser, data, cb, fail_cb)
}

function unSetOnlyBindUser(data, cb, fail_cb) {
    request.get.call(this, config.apiList.unSetOnlyBindUser, data, cb, fail_cb)
}



function removeFromBlacklist(data, cb, fail_cb) {
    request.get.call(this, config.apiList.removeFromBlacklist, data, cb, fail_cb)
}

function canAutoWithdraw(data, cb, fail_cb) {
    request.get.call(this, config.apiList.canAutoWithdraw, data, cb, fail_cb)
}



function notAutoWithdraw(data, cb, fail_cb) {
    request.get.call(this, config.apiList.notAutoWithdraw, data, cb, fail_cb)
}

function autoWithdrawWhiteList(data, cb, fail_cb) {
    request.get.call(this, config.apiList.autoWithdrawWhiteList, data, cb, fail_cb)
}



function notAutoWithdrawWhiteList(data, cb, fail_cb) {
    request.get.call(this, config.apiList.notAutoWithdrawWhiteList, data, cb, fail_cb)
}

function getUserOrderReport(data, cb, fail_cb) {
    request.get.call(this, config.apiList.userOrderReport, data, cb, fail_cb)
}

function getUserReport(data, cb, fail_cb) {
    request.get.call(this, config.apiList.userReport, data, cb, fail_cb)
}

function updateUser(data, cb, fail_cb) {
    request.post.call(this, config.apiList.updateUser + "/" + data.id, data, null, cb, fail_cb)
}
function updateRebateAgentPid(data, cb, fail_cb) {
    request.post.call(this, config.apiList.updateRebateAgentPid + "/" + data.id, data, null, cb, fail_cb)
}

function cancelRebateAgentPid(data, cb, fail_cb) {
    request.post.call(this, config.apiList.cancelRebateAgentPid + "/" + data.id, data, null, cb, fail_cb)
}


var userApi = {
    getUsers: getUsers,
    getUnionUsers: getUnionUsers,
    getUserOrderReport: getUserOrderReport,
    getUserReport: getUserReport,
    updateUser: updateUser,
    updateRebateAgentPid: updateRebateAgentPid,
    cancelRebateAgentPid: cancelRebateAgentPid,
    addToBlacklist: addToBlacklist,
    removeFromBlacklist: removeFromBlacklist,
    canAutoWithdraw: canAutoWithdraw,
    notAutoWithdraw: notAutoWithdraw,
    autoWithdrawWhiteList: autoWithdrawWhiteList,
    notAutoWithdrawWhiteList: notAutoWithdrawWhiteList,
    sendServiceChange: sendServiceChange,
    unSetOnlyBindUser: unSetOnlyBindUser,
    setOnlyBindUser: setOnlyBindUser,
}

export {userApi}